import React, { useState } from "react"
import OnBoardingContainer from "../../pages/LandingPage/components/OnBoardingContainer.js"
import TextInput from "../InputBoxes/TextInput"
import FileUpload from "../FileUpload"
import CheckBoxWithText from "../CheckBoxWithText"
import { Button } from "../Buttons"
import Card from "../Card"
import InfoContainer from "./component/InfoContainer.js"
import { useDispatch, useSelector } from "react-redux"
import { setUserData } from "../../redux/userSlice.js"
import { isPanValid } from "../../Utils/Validations.js"
import OnBoardingLeftContainer from "../../pages/LandingPage/components/onBoardingLeftContainer.js"
import DoughnutChartSecondary from "../Charts/DoughnutChartSecondary.js"
import rightArrowIcon from "../../assets/Images/icons/rightArrowIcon.svg"

const userDetails = {
  name: "Vikram Das",
  panNumber: "",
  dob: "12/12/1990",
  gender: "Male",
  email: "vikramdas@gmail.com",
  phone: "+91 8422005522",
}

const { name, dob, gender, email } = userDetails

const PANDetails = () => {
  const [isFetched, setIsFetched] = useState(false)
  const [isAuthoriseChecked, setIsAuthoriseChecked] = useState(false)
  const [isDeclarationChecked, setIsDeclarationChecked] = useState(false)
  const [panNumber, setPanNumber] = useState("")
  const [panFrontImage, setPanFrontImage] = useState(null)
  const [panBackImage, setPanBackImage] = useState(null)
  const { phoneNumber } = useSelector((state) => state.user)
  const [error, setError] = useState(false)
  const dispatch = useDispatch()

  const fetchDetails = () => {
    setIsFetched(true)
  }
  const onUserRejectIdentity = () => {
    setIsFetched(false)
  }

  const checkIsPanValid = () => {
    if (panNumber.length) {
      isPanValid(panNumber) ? setError(false) : setError(true)
    }
  }

  const onChangePanNumber = (text) => {
    setPanNumber(text?.target?.value?.toUpperCase())
    setError(false)
  }

  return isFetched ? (
    <OnBoardingContainer
      ComponentFirst={
        <OnBoardingLeftContainer
          title="Bravo! You Have Unlocked Your Credit Power."
          description="Please verify your details and have a look at what your credit score has to offer."
          onBoardingStep={1}
        />
      }
      ComponentSecond={
        <>
          <div className="flex flex-col">
            <Card className="">
              {/* <CreditScore /> */}
              <p
                className="Font-[Filson_Soft] font-bold
      text-[24px] text-[#424952] leading-[27.84px] tracking-[-0.02em]"
              >
                Your Credit Score
              </p>
              <p className="font-[Apparat] font-normal text-[16px] leading-[20px] tracking-[-0.02em] mt-2">
                Based on the data received from the CIBIL
              </p>
              <div className="flex items-center gap-[24px]">
                <DoughnutChartSecondary />
                <div>
                  <p
                    className="Font-[Filson_Soft] font-[700]
      text-[18px] text-[#424952] leading-[20.84px] tracking-[-2%]"
                  >
                    Congratulations
                  </p>
                  <p className="font-[Apparat]  font-[400] text-[14px] leading-[16.8px] tracking-[-2%] mt-[24px]">
                    You are eligible for the loan of
                  </p>
                  <p
                    className="Font-[Filson_Soft] font-bold
      text-[32px] text-[#424952] leading-[34.92px] tracking-[-2%]"
                  >
                    2,00,000
                  </p>
                </div>
              </div>
              <p className="font-[Apparat] font-[400] text-[12px] leading-[20px] tracking-[-0.02em] text-center">
                Continue to e-KYC & take the next step towards getting a loan
              </p>
            </Card>
            <Card className="my-[24px]">
              <div className="grid grid-cols-3 gap-[12px] ">
                <InfoContainer title="Pan Account Number" value={panNumber} />
                <InfoContainer title="DOB" value={dob} />
                <InfoContainer title="Gender" value={gender} />
                <InfoContainer title="Name" value={name} />
                <InfoContainer title="Email Id" value={email} />
                <InfoContainer title="Phone Number" value={phoneNumber} />
              </div>
            </Card>
            <div className="flexRow justify-between">
              <div className="flex">
                <Button
                  title="Get Your KYC Started"
                  onClick={() => dispatch(setUserData({ panNumber }))}
                />
                <span
                  className="flex cursor-pointer justify-center items-center ml-[18px] font-Apparat font-[500] text-[16px] leading-[21px] "
                  onClick={onUserRejectIdentity}
                >
                  No, this is not me
                </span>
              </div>
              <Button variant="tertiary" className="text-[#424952] px-[0px]">
                <div className="flex items-center justify-center gap-1 text-[#424952]">
                  {" "}
                  <span className="font-[600] text-[16px] leading-[16px] ">
                    Dashboard
                  </span>{" "}
                  <img src={rightArrowIcon} />
                </div>
              </Button>
            </div>
          </div>
        </>
      }
    />
  ) : (
    <>
      <OnBoardingContainer
        ComponentFirst={
          <OnBoardingLeftContainer
            title="Unlock Your Credit Power"
            description="Enter your PAN card details to check your credit score and move
          forward."
            onBoardingStep={1}
          />
        }
        ComponentSecond={
          <>
            <div className="flex flex-col">
              <p className="font-Apparat font-[600] text-[16px] leading-[24px] mb-[8px]">
                Enter Your PAN Card Number <sup className="text-[red]">*</sup>
              </p>
              <TextInput
                placeholder="ABC0000AB *"
                value={panNumber}
                onChange={(text) => onChangePanNumber(text)}
                onBlur={() => checkIsPanValid()}
                error={error ? "Invalid PAN Number" : ""}
              />

              <p className="font-Apparat font-[600] text-[16px] leading-[24px] mb-[8px] mt-[40px]">
                Add the photo <sup className="text-[red]">*</sup>  <span className="text-[#A0A4A8]">(Max File size: 5MB)</span>
              </p>
              <div className="flexRow justify-between gap-[24px]">
                <FileUpload
                  title="Pan Card Front"
                  acceptValue="image/*"
                  preview={panFrontImage?.preview}
                  onSelect={setPanFrontImage}
                  maxSize={5}
                />

                <FileUpload
                  title="Pan Card Back"
                  acceptValue="image/*"
                  preview={panBackImage?.preview}
                  onSelect={setPanBackImage}
                  maxSize={5}
                />
              </div>
              <div className="my-[40px]">
                <CheckBoxWithText
                  title="I authorise fastfin to fetch my personal information using my PAN number"
                  value={isAuthoriseChecked}
                  onClick={() => setIsAuthoriseChecked(!isAuthoriseChecked)}
                />
                <CheckBoxWithText
                  title="I declare that above information is correct and true and i allow fastfin to fetch my credit information from CIBIL"
                  value={isDeclarationChecked}
                  onClick={() => setIsDeclarationChecked(!isDeclarationChecked)}
                />
              </div>
              <div className="flex justify-between">
                <Button
                  title="Fetch"
                  onClick={() => fetchDetails()}
                  disabled={
                    !(
                      isAuthoriseChecked &&
                      isDeclarationChecked &&
                      panNumber.length === 10 &&
                      !error &&
                      panFrontImage &&
                      panBackImage
                    )
                  }
                />
                <Button variant="tertiary" className=" text-[#424952]">
                  <div className="flex items-center justify-center gap-1 text-[#424952]">
                    {" "}
                    <span className="font-[600] text-[16px] leading-[16px] ">
                      Dashboard
                    </span>{" "}
                    <img src={rightArrowIcon} />
                  </div>
                </Button>
              </div>
            </div>
          </>
        }
      />
    </>
  )
}

export default PANDetails
